import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Section from '../components/Section';

import exhibition from '../assets/images/events/exhibition 2025.jpg';
import workshops from '../assets/images/events/workshops.jpeg'


const Events = () => {

  const isMobile = useMediaQuery({ maxWidth: 601 })
  const isTablet = useMediaQuery({ minWidth: 602, maxWidth: 951 });
  const isDesktop = useMediaQuery({ minWidth: 952 });
  
  const [flexDirection, setFlexDirection] = useState('flex-row');
  const [componentWidth, setComponentWidth] = useState('w-50');
  

  useEffect(() => {
    if (isMobile) {
      setFlexDirection('flex-column-reverse');
      setComponentWidth('w-100');
    }

    if (isTablet) {
      setFlexDirection('flex-column-reverse');
      setComponentWidth('w-75');
    }

    if (isDesktop) {
      setFlexDirection('flex-row');
      setComponentWidth('w-50');
    }
  }, [isMobile, isTablet, isDesktop]);


  return (

    <>

      <Navbar/>

          
      <Section>
        <div className={`d-flex ${flexDirection} gap-3 align-items-center justify-content-center`}>
          {/* <div className={`${componentWidth} card text-bg-dark text-center`}>
            <img src={exhibition} className="card-img img-fluid" style={{ objectFit: 'cover', height: '100%' }} alt='invitation' />
          </div> */}

          <div className={`px-2 ${componentWidth} d-flex flex-column justify-content-center`}>
            <h2 className={`font-custom text-center`}>Our Annual Art Exhibition</h2>
            <p className={`font-custom text-center`}><em>la sedicesima esposizione</em></p>
            <p>Art Alive Art School warmly invites you to our Sixteenth Annual Art Exhibition, a winter celebration of creativity, community, and art.</p>
            <p>Enjoy an evening around the bonfire with wine, hearty winter food, and great company while viewing an inspiring collection of artworks.</p>
            <p>Presented in collaboration with the Rotary Club of Benoni Aurora, in aid of Clean Projects, the exhibition features works by the teachers and students of Art Alive Art School, with guest artist Mike Franks.</p>
            <p>
              <strong>Dates and times</strong><br/>
              Wednesday 29 July to Friday 31 July 4pm to 9pm<br/>
              Saturday 1 August 11am to 9pm<br/>
            </p>
            <p>
              <strong>Venue</strong><br/>
              56 11th Avenue, Northmead, Benoni<br/>
            </p>
            <p>
              <strong>Tickets</strong><br/>
              R90 per person<br/>
              Available from your favourite artist, the Art School, or your Rotary or Clean Projects host or hostess<br/>
            </p>
            <p>
              <strong>Enquiries</strong><br/>
              Elaine 084 581 6340<br/>
            </p>
          </div>
        </div>
      </Section>

      <Section>
        <div className={`${componentWidth} card text-bg-dark text-center`}>
          <img src={workshops} className="card-img img-fluid" style={{ objectFit: 'cover', height: '100%' }} alt='workshops' />
        </div>
      </Section>


      <Footer/>
    
    </>

  );

}

export default Events;